import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/cross.svg'
import _imports_1 from '@/assets/img/plus.svg'


const _withScopeId = n => (_pushScopeId("data-v-657032a1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "opModal uploadCertificationModal formContainer" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 0,
  class: "body"
}
const _hoisted_7 = { class: "row mt-4" }
const _hoisted_8 = { class: "col-6" }
const _hoisted_9 = { class: "d-block fs-18 mt-1 mb-4" }
const _hoisted_10 = { class: "col-6" }
const _hoisted_11 = { class: "d-block fs-18 mt-1 mb-4" }
const _hoisted_12 = { class: "row mt-3" }
const _hoisted_13 = {
  key: 0,
  class: "col-12"
}
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = { class: "d-flex align-items-end justify-content-between" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "col-12" }
const _hoisted_19 = { class: "col-sm-12" }
const _hoisted_20 = { class: "text-center pt-2 mb-5" }
const _hoisted_21 = { class: "text-center mt-3" }
const _hoisted_22 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_form_field = _resolveComponent("form-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_localized_text, {
          localizedKey: "Add certification",
          text: "Add certification"
        })
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-modal-close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, _hoisted_5)
    ]),
    (_ctx.loaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_localized_text, {
                localizedKey: "Section",
                text: "Section",
                type: "label"
              }),
              _createElementVNode("strong", _hoisted_9, _toDisplayString(_ctx.sectionTitle), 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_localized_text, {
                localizedKey: "Certification",
                text: "Certification",
                type: "label"
              }),
              _createElementVNode("strong", _hoisted_11, _toDisplayString(_ctx.certificationName), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            (_ctx.isMultiple)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_form_field, {
                        type: "select",
                        labelKey: "Model",
                        labelValue: "Model",
                        placeholderKey: "Select an existing model from your catalogue...",
                        placeholderValue: "Select an existing model from your catalogue...",
                        list: _ctx.companyModelList,
                        modelValue: _ctx.productModelId,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.productModelId) = $event)),
                        class: "w-100"
                      }, null, 8, ["list", "modelValue"]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-secondary ms-2 mb-4",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addNewModel())),
                        style: {"height":"50px"}
                      }, _hoisted_17)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_form_field, {
                type: "date",
                labelKey: "Expiration date",
                labelValue: "Expiration date",
                placeholderKey: "Expiration date",
                placeholderValue: "Expiration date",
                modelValue: _ctx.model.expirationDate,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.model.expirationDate) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_form_field, {
                type: "file",
                modelValue: _ctx.file,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.file) = $event)),
                fileName: _ctx.file ? _ctx.file.name : '',
                labelKey: "Document",
                labelValue: "Document"
              }, null, 8, ["modelValue", "fileName"])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_localized_text, {
              localizedKey: "N.B. once uploaded, you can't change the document until is expired",
              text: "N.B. once uploaded, you can't change the document until is expired",
              class: "fs_14 d-block"
            })
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-tertiary",
              disabled: _ctx.isSaveDisabled,
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Confirm",
                text: "Confirm"
              })
            ], 8, _hoisted_22)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}